import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3612898653/src/easymeat-web/src/features/offer-calculator/components/OfferCalculator.tsx");
